// @flow

export const TOGGLE_MENU = 'TOGGLE_MENU'
export const OPEN_MENU = 'OPEN_MENU'
